import { Injectable } from '@angular/core';

interface IHRBData {
    digital_data? : any
}

declare global {
    interface Window { _satellite: any, HRBData : IHRBData}
}

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor() {
        
    }

    pageTrack(){
        console.log("WINDOW", window)
        console.log("STA", window._satellite);
    }

    //Method to track page load
    cartPageLoad(location: string){
        try {
            window.HRBData.digital_data.page_title = location;
            window._satellite.track("page_load");
            console.log("Page load", location);
        }
        catch (e) {
            console.log("Analytics Error:", e)
        }
    }
}
